import React from 'react';

import useSettings from '../hooks/useSettings';
import SquareChip, { type SquareChipProps } from '../SquareChip';
import FormattedDateTimeRange from '../FormattedDateTimeRange';

type DateRangeSquareChipProps = {
	from?: string;
	to?: string;
} & Pick<SquareChipProps, 'icon' | 'backgroundColor'>;

export default function DateRangeSquareChip(props: DateRangeSquareChipProps) {
	const { t } = useSettings();

	return (
		<SquareChip
			label={
				props.from || props.to ? (
					<FormattedDateTimeRange from={props.from} to={props.to} />
				) : (
					t('VIEW_ITEM_NO_DATES')
				)
			}
			icon={props.icon}
			backgroundColor={props.backgroundColor}
			disabled={!props.from && !props.to}
		/>
	);
}
